import moment from "moment";
import {UserAuth} from '../model/CustomModel';

export const utilService = {
    convertDateTime(nDate: string | undefined) {
        return moment(nDate, 'YYYY-MM-DD HH:mm:ss');
    },
    convertDate(nDate: string) {
        return moment(nDate, 'YYYY-MM-DD');
    },
    convertTextarea(str?: string) {
        if (str) {
            return str.replaceAll('\n', '<br />');
        } else {
            return '';
        }
    },
    getUserAuth():UserAuth {
        const usrStr = sessionStorage.getItem('userAuth');
        let model: UserAuth = {token: '', custNo: ''};
        if (usrStr) {
            model = JSON.parse(usrStr);
        }
        return model;
    },
    DiffSecond(startDttm: any,endDttm: any):string {
        let rvalue='';
        if(startDttm !==undefined && endDttm!==undefined){
            const startDate=this.convertDateTime(startDttm);
            const endDate=this.convertDateTime(endDttm);
            const diffSec=endDate.diff(startDate,'seconds')/1000;
            rvalue=diffSec.toFixed(2).toString();
        }
        return rvalue;
    }
}
